import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "../hooks/useCms";

const TITLES = {
  "/": "On Point Homes | Idaho Custom Home Builder",
  "/available-homes": "Available Homes | New Construction Homes in Idaho | On Point Homes",
  "/custom-homes": "Custom Homes | Idaho Custom Home Builder",
  "/our-work": "Our Work | Completed Custom Homes in Idaho | On Point Homes",
  "/our-process": "Our Process | Building a Custom Home in Idaho | On Point Homes",
  "/about": "About On Point Homes | Personal Idaho Home Builder",
  "/contact": "Contact | Start Your Project | On Point Homes",
  "/reviews": "Client Reviews | On Point Homes | Idaho Home Builder",
};

const DESCRIPTIONS = {
  "/": "On Point Homes builds new construction and custom homes in Idaho with a personal, hands-on approach. Built With Intention. Built For You.",
  "/available-homes": "Browse new construction homes for sale in Idaho by On Point Homes — available, coming soon, and under construction.",
  "/custom-homes": "Thoughtfully designed custom homes — build with a hands-on Idaho custom home builder.",
  "/our-work": "A portfolio of completed custom and new construction homes built by On Point Homes in Idaho.",
  "/our-process": "A simple, transparent five-step custom home building process — from first conversation to final walkthrough.",
  "/about": "On Point Homes is a personal, hands-on Idaho home builder focused on craftsmanship, communication, and quality.",
  "/contact": "Start your project with On Point Homes. Tell us about your available home purchase or custom home build in Idaho.",
  "/reviews": "Read reviews from Idaho homeowners who built with On Point Homes — honest stories about a personal, hands-on building experience.",
};

const SEO = ({ title, description, noindex = false }) => {
  const { pathname } = useLocation();
  const seo = useSeo();

  useEffect(() => {
    const override = seo.find((s) => s.path === pathname);
    document.title = title || override?.title || TITLES[pathname] || TITLES["/"];
    const desc = description || override?.description || DESCRIPTIONS[pathname] || DESCRIPTIONS["/"];
    let tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", desc);

    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", noindex || override?.noindex ? "noindex" : "index,follow");

    if (override?.image) {
      let og = document.querySelector('meta[property="og:image"]');
      if (og) og.setAttribute("content", override.image);
    }
    window.scrollTo(0, 0);
  }, [pathname, title, description, noindex, seo]);
  return null;
};

export default SEO;
